import ComparisonResultsPageHero from "../../../../src/components/ComparisonResultsPageHero";
import ComparisonResultPageTextWithImageSection from "../../../../src/components/ComparisonResultPageTextWithImageSection";
import ComparisonResultGrid from "../../../../src/components/ComparisonResultGrid";
import ComparisonResultColumnContent from "../../../../src/components/ComparisonResultColumnContent";
import ComparisonResultColumnContentBackgroundContainer from "../../../../src/components/ComparisonResultColumnContentBackgroundContainer";
import ComparisonResultGettingStartedBlock from "../../../../src/components/ComarisonResultPageGetStartedBlock";
import ComparisonPageRecommendations from "../../../../src/components/ComparisonPageRecommendations";
import ComparisonResultPageLearnMoreContainer from "../../../../src/components/ComparisonResultPageLearnMoreContainer";
import VoIPIllustration from "../../../../svg/ComparisonResultPageIllustrations/voipservices.svg";
import OomaSVG from "../../../../svg/ComparisonResultGridLogos/voipservices/ooma.svg";
import RingSVG from "../../../../svg/ComparisonResultGridLogos/voipservices/ringcentral.svg";
import GrasshopperSVG from "../../../../svg/ComparisonResultGridLogos/voipservices/grasshopper.svg";
import GoToConnectSVG from "../../../../svg/ComparisonResultGridLogos/voipservices/gotoconnect.svg";
import EightByEightSVG from "../../../../svg/ComparisonResultGridLogos/voipservices/eightbyeight.svg";
import * as React from 'react';
export default {
  ComparisonResultsPageHero,
  ComparisonResultPageTextWithImageSection,
  ComparisonResultGrid,
  ComparisonResultColumnContent,
  ComparisonResultColumnContentBackgroundContainer,
  ComparisonResultGettingStartedBlock,
  ComparisonPageRecommendations,
  ComparisonResultPageLearnMoreContainer,
  VoIPIllustration,
  OomaSVG,
  RingSVG,
  GrasshopperSVG,
  GoToConnectSVG,
  EightByEightSVG,
  React
};